import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const DEFAULT_WIDTH = 500;

@Injectable()
export class DrawerService {
	public size = 500;
	public isOpen$ = new BehaviorSubject(false);

	open(size = DEFAULT_WIDTH) {
		this.size = size;
		this.isOpen$.next(true);
	}
	close($event = null) {
		if ($event) {
			if ($event.target.classList[0] === 'k-overlay') {
				this.isOpen$.next(false);
			}
		} else {
			this.isOpen$.next(false);
		}
	}
}
